/*
 * Autorska prava pridržava Mali mol d.o.o. Pula
 * Copyright (c) 2016. by Mali mol d.o.o. Pula. All rights reserved.
 *
 * Korištenje ili javno objavljivanje ovog programskog koda ili bilo kojeg
 * njegovog dijela, nije dozvoljeno bez prethodnog pismenog odobrenja tvrtke Mali mol d.o.o.
 *
 * Mali mol d.o.o., Špiljavac 2, 52100 Pula, Croatia
 * <URL:http://www.malimol.hr>, <mailto:info@malimol.hr>
 */

 
 

import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import InputText from 'primevue/inputtext';
import InputMask from 'primevue/inputmask';
import Textarea from 'primevue/textarea';
import Password from 'primevue/password';
import Button from 'primevue/button';
import Toast from 'primevue/toast';
import Column from 'primevue/column';
import DataView from 'primevue/dataview';
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions'   // optional
import DataTable from 'primevue/datatable';
import Dropdown from 'primevue/dropdown';
import InputNumber from 'primevue/inputnumber';
import Dialog from 'primevue/dialog';
import Toolbar from 'primevue/toolbar';
import RadioButton from 'primevue/radiobutton';
import Calendar from 'primevue/calendar';
import Checkbox from 'primevue/checkbox';
import ConfirmDialog from 'primevue/confirmdialog';
import DynamicDialog from 'primevue/dynamicdialog';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import MultiSelect from 'primevue/multiselect';
import ToggleButton from 'primevue/togglebutton';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Listbox from 'primevue/listbox';
import AutoComplete from 'primevue/autocomplete';
import TriStateCheckbox from 'primevue/tristatecheckbox';
import PickList from 'primevue/picklist';
import Message from 'primevue/message';
import ColorPicker from 'primevue/colorpicker';
import SplitButton from 'primevue/splitbutton';
import Menubar from 'primevue/menubar';
import Galleria from 'primevue/galleria';
import ContextMenu from 'primevue/contextmenu';
import InputSwitch from 'primevue/inputswitch';
import DialogService from 'primevue/dialogservice';
import FocusTrap from 'primevue/focustrap';
import Tag from 'primevue/tag';
import Menu from 'primevue/menu';
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import Badge from 'primevue/badge';
import Ripple from 'primevue/ripple';
import Tooltip from 'primevue/tooltip';
import Panel from "primevue/panel";
import FloatLabel from "primevue/floatlabel";
import Fieldset from "primevue/fieldset";
import InlineMessage from "primevue/inlinemessage";
import Card from "primevue/card";
import Skeleton from "primevue/skeleton";
import ProgressBar from "primevue/progressbar";


export const PrimeVuePlugin = {
    install(app) {
        app.use(PrimeVue, { ripple: true });
        app.use(ToastService);
        app.use(ConfirmationService);
        app.use(DialogService);
        app.directive('focustrap', FocusTrap);
        app.directive('ripple', Ripple);
        app.directive('tooltip', Tooltip);
        app.component('InputText', InputText);
        app.component('InputMask', InputMask);
        app.component('Textarea', Textarea);
        app.component('Button', Button);
        app.component('Toast', Toast);
        app.component('Password', Password);
        app.component('Column', Column);
        app.component('DataTable', DataTable);
        app.component("DataView", DataView);
        app.component("DataViewLayoutOptions", DataViewLayoutOptions);
        app.component('Dropdown', Dropdown);
        app.component('InputNumber', InputNumber);
        app.component('Dialog', Dialog);
        app.component('Toolbar', Toolbar);
        app.component('RadioButton', RadioButton);
        app.component('Checkbox', Checkbox);
        app.component('ConfirmDialog', ConfirmDialog);
        app.component('DynamicDialog', DynamicDialog)
        app.component('Calendar', Calendar);
        app.component('TabView', TabView);
        app.component('TabPanel', TabPanel);
        app.component('MultiSelect', MultiSelect);
        app.component('ToggleButton', ToggleButton);
        app.component('Accordion', Accordion);
        app.component('AccordionTab', AccordionTab);
        app.component('Listbox', Listbox);
        app.component('AutoComplete', AutoComplete);
        app.component('TriStateCheckbox', TriStateCheckbox);
        app.component('PickList', PickList);
        app.component('Message', Message);
        app.component('ColorPicker', ColorPicker);
        app.component('SplitButton', SplitButton);
        app.component('Menubar', Menubar);
        app.component('Galleria', Galleria);
        app.component('ContextMenu', ContextMenu);
        app.component('InputSwitch', InputSwitch);
        app.component('Tag', Tag);
        app.component('Menu', Menu);
        app.component('Splitter', Splitter);
        app.component('SplitterPanel', SplitterPanel);
        app.component('Badge', Badge);
        app.component('DialogService', DialogService);
        app.component("Panel", Panel);
        app.component("FloatLabel", FloatLabel);
        app.component("Fieldset", Fieldset);
        app.component("InlineMessage", InlineMessage);
        app.component("Card", Card);
        app.component("Skeleton", Skeleton);
        app.component("ProgressBar", ProgressBar);
    }
}